<template>
  <i18n-t keypath="ORGANIZATION.BUSINESS_CREDIT_DATA.CONTACT" tag="span">
    <template #email>
      <a class="text-blue-400" href="mailto:sales@lendflow.com ">
        sales@lendflow.com
      </a>
    </template>
  </i18n-t>
</template>
